// extracted by mini-css-extract-plugin
export var cardLayout = "_74-1";
export var paginationContainer = "_74-0";